import { Breadcrumbs, BreadcrumbsVariant } from '@/components/Breadcrumbs';
import { CONTENT_SPACE_CLASSNAME, EMPTY_META, FRONT_URL } from '@/constants';
import { Layout } from '@/layout';
import { InferGetServerSidePropsType } from 'next';
import styles from './Shops.module.scss';
import { ShopsBlock } from '@/components/ShopsBlock';
import { fetchData } from '@/services/fetchData';
import { ShopType } from '@/types';
import Head from 'next/head';

export default function Shops({
  list,
  description,
  seo,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${FRONT_URL}/shops`} />
      </Head>
      <Layout meta={seo}>
        <main className={styles.main}>
          <Breadcrumbs
            routes={[{ link: '/shops', text: description.title }]}
            variant={BreadcrumbsVariant.Dark}
            className={styles.breads}
          />
          <ShopsBlock shops={list} />
          {description.body && (
            <div
              className={CONTENT_SPACE_CLASSNAME}
              dangerouslySetInnerHTML={{
                __html: description.body,
              }}
            />
          )}
        </main>
      </Layout>
    </>
  );
}

export async function getServerSideProps() {
  const listRes = await fetchData({ url: '/shop/list?limit=30' });
  const descriptionRes = await fetchData({
    url: '/descriptionBlock/page/shops',
  });
  const seoRes = await fetchData({
    url: '/seo/page/shops',
  });

  if (!listRes.success) return { notFound: true };

  const list: ShopType[] = listRes.data.results;
  const description = descriptionRes.data ?? {
    title: 'Магазины',
    body: '',
  };

  return {
    props: {
      list,
      description,
      seo: seoRes.data ?? EMPTY_META,
    },
  };
}
